var m = require('mithril');

module.exports = {
  view: function(vnode){
    var ctrl = this
    ctrl.content = vnode.attrs.element
    return m('div.fl.w-100.w-50-ns.ph3.pb3', ctrl.content)
  }
}